export default __webpack_public_path__ + "static/logo-innogene-kalbiotech-ad6408c33930c54cf2428937ab05a37e.png";